export default "__VITE_PUBLIC_ASSET__e508aa9d__"